import { Component, Input } from '@angular/core';

@Component({
	selector: 'quote-client-info',
	template: require('./quote-client-info.html'),
	styles: [require('./quote-client-info.scss')]
})
export class QuoteClientInfoComponent {
	@Input('job') job;
	@Input() fromQuoteView: boolean;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/quotes/common/quote-client-info/quote-client-info.ts